import { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useStream } from '../contexts/StreamContext';
import { useGame } from '../contexts/GameContext';
import { games } from '../services/api';

const StreamingSession = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const { stream, startStream, stopStream } = useStream();
  const { gameState, updateGameState } = useGame();
  const videoRef = useRef();
  const [error, setError] = useState(null);
  const [gameData, setGameData] = useState(null);

  useEffect(() => {
    const initGame = async () => {
      try {
        const response = await games.getGameById(gameId);
        setGameData(response.data);
        await startStream(gameId);
      } catch (err) {
        setError(err.message || 'Failed to initialize game');
      }
    };
    initGame();
    return () => stopStream();
  }, [gameId, startStream, stopStream]);

  useEffect(() => {
    if (stream?.stream && videoRef.current) {
      videoRef.current.srcObject = stream.stream;
    }
  }, [stream]);

  const handleInput = (e) => {
    if (!gameData) return;
    const input = {
      type: 'input',
      game: gameData.title,
      action: e.key,
      timestamp: Date.now(),
      gameState: gameState
    };
    stream?.sendInput(input);
  };

  if (!gameData) return <div>Loading game...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="relative min-h-screen bg-gray-900">
      <video
        ref={videoRef}
        autoPlay
        playsInline
        className="w-full h-full object-contain"
      />
      <div 
        className="fixed inset-0"
        tabIndex={0}
        onKeyDown={handleInput}
        style={{ outline: 'none' }}
      />
    </div>
  );
};

export default StreamingSession;